const STORAGE_KEY = 'green-speed:announcement-dismissed';

function readStorage(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeStorage(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Ignore storage failures to keep the UI functional.
  }
}

export function initAnnouncementBar(): void {
  const bar = document.querySelector<HTMLElement>('[data-announcement-bar]');

  if (!bar) {
    return;
  }

  const dismissButton = bar.querySelector<HTMLButtonElement>('[data-announcement-dismiss]');

  if (!dismissButton) {
    return;
  }

  if (readStorage(STORAGE_KEY) === '1') {
    bar.remove();
    return;
  }

  dismissButton?.addEventListener('click', () => {
    writeStorage(STORAGE_KEY, '1');
    bar.remove();
  });
}
